import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit, inject, DestroyRef } from '@angular/core';
import { SortDefinition } from '../../models';
import {
  DataFilterManagerService,
  FilterDefinitionStoreService,
  SortDirectionEnum,
  SortDirectionType,
  SortDropdownComponent,
} from '../../../data-filter';

import { firstValueFrom } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-sort-header',
  templateUrl: './sort-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SortHeaderComponent extends SortDropdownComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private selectedOption: SortDefinition<any>;

  @HostBinding('class')
  private readonly classes = 'py-3';

  @HostBinding('attr.data-test-current-sort-direction')
  protected selectedDirection: SortDirectionType;

  constructor(
    private cd: ChangeDetectorRef,
    public filterDefinitionStoreService: FilterDefinitionStoreService,
    public dataFilterManagerService: DataFilterManagerService,
  ) {
    super(filterDefinitionStoreService, dataFilterManagerService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.selectedOption$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((selectedOption: SortDefinition<any>) => {
        this.selectedOption = selectedOption;
        this.cd.detectChanges();
      });

    this.dataFilterManagerService.getSortDirection(this.filterInstanceId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((sortDirection: SortDirectionType) => {
        this.selectedDirection = sortDirection;
        this.cd.detectChanges();
      });
  }

  isSortable(sortDefinition: SortDefinition<any>): boolean {
    return !!sortDefinition.propertySelector;
  }

  isCaretShown(sortDefinition: SortDefinition<any>): boolean {
    return sortDefinition.id === this.selectedOption?.id;
  }

  async selectHeaderSortAsync(sortOption: SortDefinition<any>): Promise<void> {
    const selectedOption = await firstValueFrom(this.selectedOption$);

    if (!this.isSortable(sortOption)) { // TODO: TO TEST
      return;
    }

    if (selectedOption.id === sortOption.id) {
      this.dataFilterManagerService.toggleSortDirection(this.filterInstanceId);
    } else {
      this.dataFilterManagerService.changeSortOption(
        this.filterInstanceId,
        sortOption.id,
        sortOption?.directionStartPriority ?? SortDirectionEnum.ASC,
      );
    }

    if (sortOption?.customFunc) {
      sortOption.customFunc();
    }
  }
}
